interface BookmarkIconProps {
  size?: number;
  color?: string;
  className?: string;
  filled?: boolean;
}

/**
 * Bookmark icon with outline and filled variants
 * Use filled prop to toggle between states
 */
export default function BookmarkIcon({ 
  size = 24, 
  color = 'currentColor',
  className = '',
  filled = false,
}: BookmarkIconProps) {
  if (filled) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M5 3C4.44772 3 4 3.44772 4 4V21C4 21.3688 4.20439 21.7077 4.53038 21.8817C4.85637 22.0557 5.25171 22.0366 5.55895 21.8321L12 17.2024L18.441 21.8321C18.7483 22.0366 19.1436 22.0557 19.4696 21.8817C19.7956 21.7077 20 21.3688 20 21V4C20 3.44772 19.5523 3 19 3H5Z"
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
